// Generated by Melange

import * as Buhta_commonapis__Buhta_common_v1_grid from "../../commonapis/gen/buhta_common_v1_grid.js";
import * as Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report from "./buhta_kassa_v1alpha1_zx_report.js";
import * as Caml_module from "melange.js/caml_module.js";
import * as Curry from "melange.js/curry.js";
import * as Ocaml_protoc_plugin from "../../../vendored/ocaml_protoc_plugin/ocaml_protoc_plugin.js";
import * as Ocaml_protoc_plugin__Deserialize from "../../../vendored/ocaml_protoc_plugin/deserialize.js";
import * as Ocaml_protoc_plugin__Deserialize_json from "../../../vendored/ocaml_protoc_plugin/deserialize_json.js";
import * as Ocaml_protoc_plugin__Merge from "../../../vendored/ocaml_protoc_plugin/merge.js";
import * as Ocaml_protoc_plugin__Result from "../../../vendored/ocaml_protoc_plugin/result.js";
import * as Ocaml_protoc_plugin__Serialize from "../../../vendored/ocaml_protoc_plugin/serialize.js";
import * as Ocaml_protoc_plugin__Serialize_json from "../../../vendored/ocaml_protoc_plugin/serialize_json.js";
import * as Ocaml_protoc_plugin__Spec from "../../../vendored/ocaml_protoc_plugin/spec.js";
import * as Ocaml_protoc_plugin__Writer from "../../../vendored/ocaml_protoc_plugin/writer.js";

const Imported$pmodules = {};

const GetZxReportRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1029,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const GetZxReportResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1095,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListZxReportsRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1156,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const ListZxReportsResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1219,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateXReportRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1279,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CreateXReportResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1339,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CloseShiftRequest = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1430,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "CloseShiftData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

const CloseShiftResponse = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1553,
      12
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name(param) {
  return ".buhta.kassa.v1alpha1.GetZxReportRequest";
}

function make(kkm_idOpt, idOpt, expandOpt, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  const id = idOpt !== undefined ? idOpt : "";
  const expand = expandOpt !== undefined ? expandOpt : /* [] */0;
  return {
          kkm_id: kkm_id,
          id: id,
          expand: expand
        };
}

const merge_kkm_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_id = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            2,
            "id",
            "id"
          ],
          Ocaml_protoc_plugin__Spec.string,
          ""
        ]));

const merge_expand = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            3,
            "expand",
            "expand"
          ],
          Ocaml_protoc_plugin__Spec.string,
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id, t1.kkm_id, t2.kkm_id),
          id: Curry._2(merge_id, t1.id, t2.id),
          expand: Curry._2(merge_expand, t1.expand, t2.expand)
        };
}

function spec(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                      [
                        2,
                        "id",
                        "id"
                      ],
                      Ocaml_protoc_plugin__Spec.string,
                      ""
                    ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                          [
                            3,
                            "expand",
                            "expand"
                          ],
                          Ocaml_protoc_plugin__Spec.string,
                          Ocaml_protoc_plugin__Spec.not_packed
                        ]), Ocaml_protoc_plugin__Spec.nil)));
}

const serialize = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec(undefined));
    });

function to_proto$p(writer, param) {
  Curry._4(serialize, writer, param.kkm_id, param.id, param.expand);
}

function to_proto(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p(writer, t);
  return writer;
}

function constructor(kkm_id, id, expand) {
  return {
          kkm_id: kkm_id,
          id: id,
          expand: expand
        };
}

const from_proto_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec(undefined), constructor);
    });

function from_proto(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn, writer);
            });
}

function to_json(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetZxReportRequest", spec(undefined))(options);
  return function (param) {
    return Curry._3(serialize, param.kkm_id, param.id, param.expand);
  };
}

function constructor$1(kkm_id, id, expand) {
  return {
          kkm_id: kkm_id,
          id: id,
          expand: expand
        };
}

const from_json_exn = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetZxReportRequest", spec(undefined), constructor$1);
    });

function from_json(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetZxReportRequest, {
      make: make,
      to_proto: to_proto,
      from_proto: from_proto,
      to_json: to_json,
      from_json: from_json,
      name: name,
      merge: merge,
      to_proto$p: to_proto$p,
      from_proto_exn: from_proto_exn,
      from_json_exn: from_json_exn
    });

function name$1(param) {
  return ".buhta.kassa.v1alpha1.GetZxReportResponse";
}

function make$1(zx_report, param) {
  return {
          zx_report: zx_report
        };
}

const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;

const merge_zx_report = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "zx_report",
            "zxReport"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let.name,
                make: $$let.make,
                from_proto: $$let.from_proto,
                from_proto_exn: $$let.from_proto_exn,
                to_proto: $$let.to_proto,
                to_proto$p: $$let.to_proto$p,
                merge: $$let.merge,
                to_json: $$let.to_json,
                from_json_exn: $$let.from_json_exn,
                from_json: $$let.from_json
              })
        ]));

function merge$1(t1, t2) {
  return {
          zx_report: Curry._2(merge_zx_report, t1.zx_report, t2.zx_report)
        };
}

function spec$1(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "zx_report",
                    "zxReport"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$1(undefined));
    });

function to_proto$p$1(writer, param) {
  Curry._2(serialize$1, writer, param.zx_report);
}

function to_proto$1(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$1(writer, t);
  return writer;
}

function constructor$2(zx_report) {
  return {
          zx_report: zx_report
        };
}

const from_proto_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$1(undefined), constructor$2);
    });

function from_proto$1(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$1, writer);
            });
}

function to_json$1(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.GetZxReportResponse", spec$1(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.zx_report);
  };
}

function constructor$3(zx_report) {
  return {
          zx_report: zx_report
        };
}

const from_json_exn$1 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.GetZxReportResponse", spec$1(undefined), constructor$3);
    });

function from_json$1(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$1, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, GetZxReportResponse, {
      make: make$1,
      to_proto: to_proto$1,
      from_proto: from_proto$1,
      to_json: to_json$1,
      from_json: from_json$1,
      name: name$1,
      merge: merge$1,
      to_proto$p: to_proto$p$1,
      from_proto_exn: from_proto_exn$1,
      from_json_exn: from_json_exn$1
    });

function name$2(param) {
  return ".buhta.kassa.v1alpha1.ListZxReportsRequest";
}

function make$2(kkm_idOpt, grid, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const merge_kkm_id$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const $$let$1 = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;

const merge_grid = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "grid",
            "grid"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$1.name,
                make: $$let$1.make,
                from_proto: $$let$1.from_proto,
                from_proto_exn: $$let$1.from_proto_exn,
                to_proto: $$let$1.to_proto,
                to_proto$p: $$let$1.to_proto$p,
                merge: $$let$1.merge,
                to_json: $$let$1.to_json,
                from_json_exn: $$let$1.from_json_exn,
                from_json: $$let$1.from_json
              })
        ]));

function merge$2(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id$1, t1.kkm_id, t2.kkm_id),
          grid: Curry._2(merge_grid, t1.grid, t2.grid)
        };
}

function spec$2(param) {
  const $$let = Buhta_commonapis__Buhta_common_v1_grid.Buhta.Common.V1.GridRequest;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "grid",
                        "grid"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: $$let.name,
                            make: $$let.make,
                            from_proto: $$let.from_proto,
                            from_proto_exn: $$let.from_proto_exn,
                            to_proto: $$let.to_proto,
                            to_proto$p: $$let.to_proto$p,
                            merge: $$let.merge,
                            to_json: $$let.to_json,
                            from_json_exn: $$let.from_json_exn,
                            from_json: $$let.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$2(undefined));
    });

function to_proto$p$2(writer, param) {
  Curry._3(serialize$2, writer, param.kkm_id, param.grid);
}

function to_proto$2(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$2(writer, t);
  return writer;
}

function constructor$4(kkm_id, grid) {
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const from_proto_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$2(undefined), constructor$4);
    });

function from_proto$2(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$2, writer);
            });
}

function to_json$2(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListZxReportsRequest", spec$2(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kkm_id, param.grid);
  };
}

function constructor$5(kkm_id, grid) {
  return {
          kkm_id: kkm_id,
          grid: grid
        };
}

const from_json_exn$2 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListZxReportsRequest", spec$2(undefined), constructor$5);
    });

function from_json$2(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$2, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListZxReportsRequest, {
      make: make$2,
      to_proto: to_proto$2,
      from_proto: from_proto$2,
      to_json: to_json$2,
      from_json: from_json$2,
      name: name$2,
      merge: merge$2,
      to_proto$p: to_proto$p$2,
      from_proto_exn: from_proto_exn$2,
      from_json_exn: from_json_exn$2
    });

function name$3(param) {
  return ".buhta.kassa.v1alpha1.ListZxReportsResponse";
}

function make$3(zx_reportsOpt, param) {
  const zx_reports = zx_reportsOpt !== undefined ? zx_reportsOpt : /* [] */0;
  return {
          zx_reports: zx_reports
        };
}

const $$let$2 = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;

const merge_zx_reports = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.repeated([
          [
            1,
            "zx_reports",
            "zxReports"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$2.name,
                make: $$let$2.make,
                from_proto: $$let$2.from_proto,
                from_proto_exn: $$let$2.from_proto_exn,
                to_proto: $$let$2.to_proto,
                to_proto$p: $$let$2.to_proto$p,
                merge: $$let$2.merge,
                to_json: $$let$2.to_json,
                from_json_exn: $$let$2.from_json_exn,
                from_json: $$let$2.from_json
              }),
          Ocaml_protoc_plugin__Spec.not_packed
        ]));

function merge$3(t1, t2) {
  return {
          zx_reports: Curry._2(merge_zx_reports, t1.zx_reports, t2.zx_reports)
        };
}

function spec$3(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.repeated([
                  [
                    1,
                    "zx_reports",
                    "zxReports"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      }),
                  Ocaml_protoc_plugin__Spec.not_packed
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$3(undefined));
    });

function to_proto$p$3(writer, param) {
  Curry._2(serialize$3, writer, param.zx_reports);
}

function to_proto$3(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$3(writer, t);
  return writer;
}

function constructor$6(zx_reports) {
  return {
          zx_reports: zx_reports
        };
}

const from_proto_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$3(undefined), constructor$6);
    });

function from_proto$3(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$3, writer);
            });
}

function to_json$3(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.ListZxReportsResponse", spec$3(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.zx_reports);
  };
}

function constructor$7(zx_reports) {
  return {
          zx_reports: zx_reports
        };
}

const from_json_exn$3 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.ListZxReportsResponse", spec$3(undefined), constructor$7);
    });

function from_json$3(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$3, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, ListZxReportsResponse, {
      make: make$3,
      to_proto: to_proto$3,
      from_proto: from_proto$3,
      to_json: to_json$3,
      from_json: from_json$3,
      name: name$3,
      merge: merge$3,
      to_proto$p: to_proto$p$3,
      from_proto_exn: from_proto_exn$3,
      from_json_exn: from_json_exn$3
    });

function name$4(param) {
  return ".buhta.kassa.v1alpha1.CreateXReportRequest";
}

function make$4(kkm_idOpt, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
          kkm_id: kkm_id
        };
}

const merge_kkm_id$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

function merge$4(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id$2, t1.kkm_id, t2.kkm_id)
        };
}

function spec$4(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$4(undefined));
    });

function to_proto$p$4(writer, param) {
  Curry._2(serialize$4, writer, param.kkm_id);
}

function to_proto$4(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$4(writer, t);
  return writer;
}

function constructor$8(kkm_id) {
  return {
          kkm_id: kkm_id
        };
}

const from_proto_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$4(undefined), constructor$8);
    });

function from_proto$4(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$4, writer);
            });
}

function to_json$4(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateXReportRequest", spec$4(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.kkm_id);
  };
}

function constructor$9(kkm_id) {
  return {
          kkm_id: kkm_id
        };
}

const from_json_exn$4 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateXReportRequest", spec$4(undefined), constructor$9);
    });

function from_json$4(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$4, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateXReportRequest, {
      make: make$4,
      to_proto: to_proto$4,
      from_proto: from_proto$4,
      to_json: to_json$4,
      from_json: from_json$4,
      name: name$4,
      merge: merge$4,
      to_proto$p: to_proto$p$4,
      from_proto_exn: from_proto_exn$4,
      from_json_exn: from_json_exn$4
    });

function name$5(param) {
  return ".buhta.kassa.v1alpha1.CreateXReportResponse";
}

function make$5(zx_report, param) {
  return {
          zx_report: zx_report
        };
}

const $$let$3 = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;

const merge_zx_report$1 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "zx_report",
            "zxReport"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$3.name,
                make: $$let$3.make,
                from_proto: $$let$3.from_proto,
                from_proto_exn: $$let$3.from_proto_exn,
                to_proto: $$let$3.to_proto,
                to_proto$p: $$let$3.to_proto$p,
                merge: $$let$3.merge,
                to_json: $$let$3.to_json,
                from_json_exn: $$let$3.from_json_exn,
                from_json: $$let$3.from_json
              })
        ]));

function merge$5(t1, t2) {
  return {
          zx_report: Curry._2(merge_zx_report$1, t1.zx_report, t2.zx_report)
        };
}

function spec$5(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "zx_report",
                    "zxReport"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$5(undefined));
    });

function to_proto$p$5(writer, param) {
  Curry._2(serialize$5, writer, param.zx_report);
}

function to_proto$5(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$5(writer, t);
  return writer;
}

function constructor$10(zx_report) {
  return {
          zx_report: zx_report
        };
}

const from_proto_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$5(undefined), constructor$10);
    });

function from_proto$5(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$5, writer);
            });
}

function to_json$5(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CreateXReportResponse", spec$5(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.zx_report);
  };
}

function constructor$11(zx_report) {
  return {
          zx_report: zx_report
        };
}

const from_json_exn$5 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CreateXReportResponse", spec$5(undefined), constructor$11);
    });

function from_json$5(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$5, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CreateXReportResponse, {
      make: make$5,
      to_proto: to_proto$5,
      from_proto: from_proto$5,
      to_json: to_json$5,
      from_json: from_json$5,
      name: name$5,
      merge: merge$5,
      to_proto$p: to_proto$p$5,
      from_proto_exn: from_proto_exn$5,
      from_json_exn: from_json_exn$5
    });

const CloseShiftData = Caml_module.init_mod([
      "proto/kassaapis/gen/buhta_kassa_v1alpha1_zx_report_service.ml",
      1461,
      14
    ], {
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    });

function name$6(param) {
  return ".buhta.kassa.v1alpha1.CloseShiftRequest.CloseShiftData";
}

function make$6(withdraw_cashOpt, param) {
  const withdraw_cash = withdraw_cashOpt !== undefined ? withdraw_cashOpt : false;
  return {
          withdraw_cash: withdraw_cash
        };
}

const merge_withdraw_cash = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "withdraw_cash",
            "withdrawCash"
          ],
          Ocaml_protoc_plugin__Spec.bool,
          false
        ]));

function merge$6(t1, t2) {
  return {
          withdraw_cash: Curry._2(merge_withdraw_cash, t1.withdraw_cash, t2.withdraw_cash)
        };
}

function spec$6(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "withdraw_cash",
                    "withdrawCash"
                  ],
                  Ocaml_protoc_plugin__Spec.bool,
                  false
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$6(undefined));
    });

function to_proto$p$6(writer, param) {
  Curry._2(serialize$6, writer, param.withdraw_cash);
}

function to_proto$6(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$6(writer, t);
  return writer;
}

function constructor$12(withdraw_cash) {
  return {
          withdraw_cash: withdraw_cash
        };
}

const from_proto_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$6(undefined), constructor$12);
    });

function from_proto$6(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$6, writer);
            });
}

function to_json$6(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CloseShiftRequest.CloseShiftData", spec$6(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.withdraw_cash);
  };
}

function constructor$13(withdraw_cash) {
  return {
          withdraw_cash: withdraw_cash
        };
}

const from_json_exn$6 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CloseShiftRequest.CloseShiftData", spec$6(undefined), constructor$13);
    });

function from_json$6(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$6, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CloseShiftData, {
      make: make$6,
      to_proto: to_proto$6,
      from_proto: from_proto$6,
      to_json: to_json$6,
      from_json: from_json$6,
      name: name$6,
      merge: merge$6,
      to_proto$p: to_proto$p$6,
      from_proto_exn: from_proto_exn$6,
      from_json_exn: from_json_exn$6
    });

function name$7(param) {
  return ".buhta.kassa.v1alpha1.CloseShiftRequest";
}

function make$7(kkm_idOpt, close_shift, param) {
  const kkm_id = kkm_idOpt !== undefined ? kkm_idOpt : 0;
  return {
          kkm_id: kkm_id,
          close_shift: close_shift
        };
}

const merge_kkm_id$3 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic([
          [
            1,
            "kkm_id",
            "kkmId"
          ],
          Ocaml_protoc_plugin__Spec.int32_int,
          0
        ]));

const merge_close_shift = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            2,
            "close_shift",
            "closeShift"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: CloseShiftData.name,
                make: CloseShiftData.make,
                from_proto: CloseShiftData.from_proto,
                from_proto_exn: CloseShiftData.from_proto_exn,
                to_proto: CloseShiftData.to_proto,
                to_proto$p: CloseShiftData.to_proto$p,
                merge: CloseShiftData.merge,
                to_json: CloseShiftData.to_json,
                from_json_exn: CloseShiftData.from_json_exn,
                from_json: CloseShiftData.from_json
              })
        ]));

function merge$7(t1, t2) {
  return {
          kkm_id: Curry._2(merge_kkm_id$3, t1.kkm_id, t2.kkm_id),
          close_shift: Curry._2(merge_close_shift, t1.close_shift, t2.close_shift)
        };
}

function spec$7(param) {
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic([
                  [
                    1,
                    "kkm_id",
                    "kkmId"
                  ],
                  Ocaml_protoc_plugin__Spec.int32_int,
                  0
                ]), Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                      [
                        2,
                        "close_shift",
                        "closeShift"
                      ],
                      Ocaml_protoc_plugin__Spec.message({
                            name: CloseShiftData.name,
                            make: CloseShiftData.make,
                            from_proto: CloseShiftData.from_proto,
                            from_proto_exn: CloseShiftData.from_proto_exn,
                            to_proto: CloseShiftData.to_proto,
                            to_proto$p: CloseShiftData.to_proto$p,
                            merge: CloseShiftData.merge,
                            to_json: CloseShiftData.to_json,
                            from_json_exn: CloseShiftData.from_json_exn,
                            from_json: CloseShiftData.from_json
                          })
                    ]), Ocaml_protoc_plugin__Spec.nil));
}

const serialize$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$7(undefined));
    });

function to_proto$p$7(writer, param) {
  Curry._3(serialize$7, writer, param.kkm_id, param.close_shift);
}

function to_proto$7(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$7(writer, t);
  return writer;
}

function constructor$14(kkm_id, close_shift) {
  return {
          kkm_id: kkm_id,
          close_shift: close_shift
        };
}

const from_proto_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$7(undefined), constructor$14);
    });

function from_proto$7(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$7, writer);
            });
}

function to_json$7(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CloseShiftRequest", spec$7(undefined))(options);
  return function (param) {
    return Curry._2(serialize, param.kkm_id, param.close_shift);
  };
}

function constructor$15(kkm_id, close_shift) {
  return {
          kkm_id: kkm_id,
          close_shift: close_shift
        };
}

const from_json_exn$7 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CloseShiftRequest", spec$7(undefined), constructor$15);
    });

function from_json$7(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$7, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          {
            TAG: /* Module */0,
            _0: [
              [
                /* Function */0,
                "make"
              ],
              [
                /* Function */0,
                "to_proto"
              ],
              [
                /* Function */0,
                "from_proto"
              ],
              [
                /* Function */0,
                "to_json"
              ],
              [
                /* Function */0,
                "from_json"
              ],
              [
                /* Function */0,
                "name"
              ],
              [
                /* Function */0,
                "merge"
              ],
              [
                /* Function */0,
                "to_proto$p"
              ],
              [
                /* Function */0,
                "from_proto_exn"
              ],
              [
                /* Function */0,
                "from_json_exn"
              ]
            ]
          },
          "CloseShiftData"
        ],
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CloseShiftRequest, {
      CloseShiftData: CloseShiftData,
      make: make$7,
      to_proto: to_proto$7,
      from_proto: from_proto$7,
      to_json: to_json$7,
      from_json: from_json$7,
      name: name$7,
      merge: merge$7,
      to_proto$p: to_proto$p$7,
      from_proto_exn: from_proto_exn$7,
      from_json_exn: from_json_exn$7
    });

function name$8(param) {
  return ".buhta.kassa.v1alpha1.CloseShiftResponse";
}

function make$8(zx_report, param) {
  return {
          zx_report: zx_report
        };
}

const $$let$4 = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;

const merge_zx_report$2 = Ocaml_protoc_plugin__Merge.merge(Ocaml_protoc_plugin__Spec.basic_opt([
          [
            1,
            "zx_report",
            "zxReport"
          ],
          Ocaml_protoc_plugin__Spec.message({
                name: $$let$4.name,
                make: $$let$4.make,
                from_proto: $$let$4.from_proto,
                from_proto_exn: $$let$4.from_proto_exn,
                to_proto: $$let$4.to_proto,
                to_proto$p: $$let$4.to_proto$p,
                merge: $$let$4.merge,
                to_json: $$let$4.to_json,
                from_json_exn: $$let$4.from_json_exn,
                from_json: $$let$4.from_json
              })
        ]));

function merge$8(t1, t2) {
  return {
          zx_report: Curry._2(merge_zx_report$2, t1.zx_report, t2.zx_report)
        };
}

function spec$8(param) {
  const $$let = Buhta_kassaapis__Buhta_kassa_v1alpha1_zx_report.Buhta.Kassa.V1alpha1.ZxReport;
  return Ocaml_protoc_plugin__Spec.$caret$colon$colon(Ocaml_protoc_plugin__Spec.basic_opt([
                  [
                    1,
                    "zx_report",
                    "zxReport"
                  ],
                  Ocaml_protoc_plugin__Spec.message({
                        name: $$let.name,
                        make: $$let.make,
                        from_proto: $$let.from_proto,
                        from_proto_exn: $$let.from_proto_exn,
                        to_proto: $$let.to_proto,
                        to_proto$p: $$let.to_proto$p,
                        merge: $$let.merge,
                        to_json: $$let.to_json,
                        from_json_exn: $$let.from_json_exn,
                        from_json: $$let.from_json
                      })
                ]), Ocaml_protoc_plugin__Spec.nil);
}

const serialize$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Serialize.serialize(spec$8(undefined));
    });

function to_proto$p$8(writer, param) {
  Curry._2(serialize$8, writer, param.zx_report);
}

function to_proto$8(t) {
  const writer = Ocaml_protoc_plugin__Writer.init(undefined, undefined, undefined);
  to_proto$p$8(writer, t);
  return writer;
}

function constructor$16(zx_report) {
  return {
          zx_report: zx_report
        };
}

const from_proto_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize.deserialize(spec$8(undefined), constructor$16);
    });

function from_proto$8(writer) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_proto_exn$8, writer);
            });
}

function to_json$8(options) {
  const serialize = Ocaml_protoc_plugin__Serialize_json.serialize(".buhta.kassa.v1alpha1.CloseShiftResponse", spec$8(undefined))(options);
  return function (param) {
    return Curry._1(serialize, param.zx_report);
  };
}

function constructor$17(zx_report) {
  return {
          zx_report: zx_report
        };
}

const from_json_exn$8 = Ocaml_protoc_plugin.apply_lazy(function (param) {
      return Ocaml_protoc_plugin__Deserialize_json.deserialize(".buhta.kassa.v1alpha1.CloseShiftResponse", spec$8(undefined), constructor$17);
    });

function from_json$8(json) {
  return Ocaml_protoc_plugin__Result.$$catch(function (param) {
              return Curry._1(from_json_exn$8, json);
            });
}

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [
        [
          /* Function */0,
          "make"
        ],
        [
          /* Function */0,
          "to_proto"
        ],
        [
          /* Function */0,
          "from_proto"
        ],
        [
          /* Function */0,
          "to_json"
        ],
        [
          /* Function */0,
          "from_json"
        ],
        [
          /* Function */0,
          "name"
        ],
        [
          /* Function */0,
          "merge"
        ],
        [
          /* Function */0,
          "to_proto$p"
        ],
        [
          /* Function */0,
          "from_proto_exn"
        ],
        [
          /* Function */0,
          "from_json_exn"
        ]
      ]
    }, CloseShiftResponse, {
      make: make$8,
      to_proto: to_proto$8,
      from_proto: from_proto$8,
      to_json: to_json$8,
      from_json: from_json$8,
      name: name$8,
      merge: merge$8,
      to_proto$p: to_proto$p$8,
      from_proto_exn: from_proto_exn$8,
      from_json_exn: from_json_exn$8
    });

const getZxReport_0 = {
  name: GetZxReportRequest.name,
  make: GetZxReportRequest.make,
  from_proto: GetZxReportRequest.from_proto,
  from_proto_exn: GetZxReportRequest.from_proto_exn,
  to_proto: GetZxReportRequest.to_proto,
  to_proto$p: GetZxReportRequest.to_proto$p,
  merge: GetZxReportRequest.merge,
  to_json: GetZxReportRequest.to_json,
  from_json_exn: GetZxReportRequest.from_json_exn,
  from_json: GetZxReportRequest.from_json
};

const getZxReport_1 = {
  name: GetZxReportResponse.name,
  make: GetZxReportResponse.make,
  from_proto: GetZxReportResponse.from_proto,
  from_proto_exn: GetZxReportResponse.from_proto_exn,
  to_proto: GetZxReportResponse.to_proto,
  to_proto$p: GetZxReportResponse.to_proto$p,
  merge: GetZxReportResponse.merge,
  to_json: GetZxReportResponse.to_json,
  from_json_exn: GetZxReportResponse.from_json_exn,
  from_json: GetZxReportResponse.from_json
};

const getZxReport = [
  getZxReport_0,
  getZxReport_1
];

const listZxReports_0 = {
  name: ListZxReportsRequest.name,
  make: ListZxReportsRequest.make,
  from_proto: ListZxReportsRequest.from_proto,
  from_proto_exn: ListZxReportsRequest.from_proto_exn,
  to_proto: ListZxReportsRequest.to_proto,
  to_proto$p: ListZxReportsRequest.to_proto$p,
  merge: ListZxReportsRequest.merge,
  to_json: ListZxReportsRequest.to_json,
  from_json_exn: ListZxReportsRequest.from_json_exn,
  from_json: ListZxReportsRequest.from_json
};

const listZxReports_1 = {
  name: ListZxReportsResponse.name,
  make: ListZxReportsResponse.make,
  from_proto: ListZxReportsResponse.from_proto,
  from_proto_exn: ListZxReportsResponse.from_proto_exn,
  to_proto: ListZxReportsResponse.to_proto,
  to_proto$p: ListZxReportsResponse.to_proto$p,
  merge: ListZxReportsResponse.merge,
  to_json: ListZxReportsResponse.to_json,
  from_json_exn: ListZxReportsResponse.from_json_exn,
  from_json: ListZxReportsResponse.from_json
};

const listZxReports = [
  listZxReports_0,
  listZxReports_1
];

const createXReport_0 = {
  name: CreateXReportRequest.name,
  make: CreateXReportRequest.make,
  from_proto: CreateXReportRequest.from_proto,
  from_proto_exn: CreateXReportRequest.from_proto_exn,
  to_proto: CreateXReportRequest.to_proto,
  to_proto$p: CreateXReportRequest.to_proto$p,
  merge: CreateXReportRequest.merge,
  to_json: CreateXReportRequest.to_json,
  from_json_exn: CreateXReportRequest.from_json_exn,
  from_json: CreateXReportRequest.from_json
};

const createXReport_1 = {
  name: CreateXReportResponse.name,
  make: CreateXReportResponse.make,
  from_proto: CreateXReportResponse.from_proto,
  from_proto_exn: CreateXReportResponse.from_proto_exn,
  to_proto: CreateXReportResponse.to_proto,
  to_proto$p: CreateXReportResponse.to_proto$p,
  merge: CreateXReportResponse.merge,
  to_json: CreateXReportResponse.to_json,
  from_json_exn: CreateXReportResponse.from_json_exn,
  from_json: CreateXReportResponse.from_json
};

const createXReport = [
  createXReport_0,
  createXReport_1
];

const closeShift_0 = {
  name: CloseShiftRequest.name,
  make: CloseShiftRequest.make,
  from_proto: CloseShiftRequest.from_proto,
  from_proto_exn: CloseShiftRequest.from_proto_exn,
  to_proto: CloseShiftRequest.to_proto,
  to_proto$p: CloseShiftRequest.to_proto$p,
  merge: CloseShiftRequest.merge,
  to_json: CloseShiftRequest.to_json,
  from_json_exn: CloseShiftRequest.from_json_exn,
  from_json: CloseShiftRequest.from_json
};

const closeShift_1 = {
  name: CloseShiftResponse.name,
  make: CloseShiftResponse.make,
  from_proto: CloseShiftResponse.from_proto,
  from_proto_exn: CloseShiftResponse.from_proto_exn,
  to_proto: CloseShiftResponse.to_proto,
  to_proto$p: CloseShiftResponse.to_proto$p,
  merge: CloseShiftResponse.merge,
  to_json: CloseShiftResponse.to_json,
  from_json_exn: CloseShiftResponse.from_json_exn,
  from_json: CloseShiftResponse.from_json
};

const closeShift = [
  closeShift_0,
  closeShift_1
];

const V1alpha1_ZxReportService = {
  GetZxReport: {
    name: "/buhta.kassa.v1alpha1.ZxReportService/GetZxReport",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "ZxReportService",
    method_name: "GetZxReport",
    $$Request: {
      name: GetZxReportRequest.name,
      make: GetZxReportRequest.make,
      from_proto: GetZxReportRequest.from_proto,
      from_proto_exn: GetZxReportRequest.from_proto_exn,
      to_proto: GetZxReportRequest.to_proto,
      to_proto$p: GetZxReportRequest.to_proto$p,
      merge: GetZxReportRequest.merge,
      to_json: GetZxReportRequest.to_json,
      from_json_exn: GetZxReportRequest.from_json_exn,
      from_json: GetZxReportRequest.from_json
    },
    $$Response: {
      name: GetZxReportResponse.name,
      make: GetZxReportResponse.make,
      from_proto: GetZxReportResponse.from_proto,
      from_proto_exn: GetZxReportResponse.from_proto_exn,
      to_proto: GetZxReportResponse.to_proto,
      to_proto$p: GetZxReportResponse.to_proto$p,
      merge: GetZxReportResponse.merge,
      to_json: GetZxReportResponse.to_json,
      from_json_exn: GetZxReportResponse.from_json_exn,
      from_json: GetZxReportResponse.from_json
    }
  },
  getZxReport: getZxReport,
  ListZxReports: {
    name: "/buhta.kassa.v1alpha1.ZxReportService/ListZxReports",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "ZxReportService",
    method_name: "ListZxReports",
    $$Request: {
      name: ListZxReportsRequest.name,
      make: ListZxReportsRequest.make,
      from_proto: ListZxReportsRequest.from_proto,
      from_proto_exn: ListZxReportsRequest.from_proto_exn,
      to_proto: ListZxReportsRequest.to_proto,
      to_proto$p: ListZxReportsRequest.to_proto$p,
      merge: ListZxReportsRequest.merge,
      to_json: ListZxReportsRequest.to_json,
      from_json_exn: ListZxReportsRequest.from_json_exn,
      from_json: ListZxReportsRequest.from_json
    },
    $$Response: {
      name: ListZxReportsResponse.name,
      make: ListZxReportsResponse.make,
      from_proto: ListZxReportsResponse.from_proto,
      from_proto_exn: ListZxReportsResponse.from_proto_exn,
      to_proto: ListZxReportsResponse.to_proto,
      to_proto$p: ListZxReportsResponse.to_proto$p,
      merge: ListZxReportsResponse.merge,
      to_json: ListZxReportsResponse.to_json,
      from_json_exn: ListZxReportsResponse.from_json_exn,
      from_json: ListZxReportsResponse.from_json
    }
  },
  listZxReports: listZxReports,
  CreateXReport: {
    name: "/buhta.kassa.v1alpha1.ZxReportService/CreateXReport",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "ZxReportService",
    method_name: "CreateXReport",
    $$Request: {
      name: CreateXReportRequest.name,
      make: CreateXReportRequest.make,
      from_proto: CreateXReportRequest.from_proto,
      from_proto_exn: CreateXReportRequest.from_proto_exn,
      to_proto: CreateXReportRequest.to_proto,
      to_proto$p: CreateXReportRequest.to_proto$p,
      merge: CreateXReportRequest.merge,
      to_json: CreateXReportRequest.to_json,
      from_json_exn: CreateXReportRequest.from_json_exn,
      from_json: CreateXReportRequest.from_json
    },
    $$Response: {
      name: CreateXReportResponse.name,
      make: CreateXReportResponse.make,
      from_proto: CreateXReportResponse.from_proto,
      from_proto_exn: CreateXReportResponse.from_proto_exn,
      to_proto: CreateXReportResponse.to_proto,
      to_proto$p: CreateXReportResponse.to_proto$p,
      merge: CreateXReportResponse.merge,
      to_json: CreateXReportResponse.to_json,
      from_json_exn: CreateXReportResponse.from_json_exn,
      from_json: CreateXReportResponse.from_json
    }
  },
  createXReport: createXReport,
  CloseShift: {
    name: "/buhta.kassa.v1alpha1.ZxReportService/CloseShift",
    package_name: "buhta.kassa.v1alpha1",
    service_name: "ZxReportService",
    method_name: "CloseShift",
    $$Request: {
      name: CloseShiftRequest.name,
      make: CloseShiftRequest.make,
      from_proto: CloseShiftRequest.from_proto,
      from_proto_exn: CloseShiftRequest.from_proto_exn,
      to_proto: CloseShiftRequest.to_proto,
      to_proto$p: CloseShiftRequest.to_proto$p,
      merge: CloseShiftRequest.merge,
      to_json: CloseShiftRequest.to_json,
      from_json_exn: CloseShiftRequest.from_json_exn,
      from_json: CloseShiftRequest.from_json
    },
    $$Response: {
      name: CloseShiftResponse.name,
      make: CloseShiftResponse.make,
      from_proto: CloseShiftResponse.from_proto,
      from_proto_exn: CloseShiftResponse.from_proto_exn,
      to_proto: CloseShiftResponse.to_proto,
      to_proto$p: CloseShiftResponse.to_proto$p,
      merge: CloseShiftResponse.merge,
      to_json: CloseShiftResponse.to_json,
      from_json_exn: CloseShiftResponse.from_json_exn,
      from_json: CloseShiftResponse.from_json
    }
  },
  closeShift: closeShift
};

const V1alpha1 = {
  GetZxReportRequest: GetZxReportRequest,
  GetZxReportResponse: GetZxReportResponse,
  ListZxReportsRequest: ListZxReportsRequest,
  ListZxReportsResponse: ListZxReportsResponse,
  CreateXReportRequest: CreateXReportRequest,
  CreateXReportResponse: CreateXReportResponse,
  CloseShiftRequest: CloseShiftRequest,
  CloseShiftResponse: CloseShiftResponse,
  ZxReportService: V1alpha1_ZxReportService
};

const Kassa = {
  V1alpha1: V1alpha1
};

const Buhta = {
  Kassa: Kassa
};

export {
  Imported$pmodules ,
  Buhta ,
}
/* GetZxReportRequest Not a pure module */
